// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2hCxd";
export var previousNext = "footer-module--previousNext--3cATG";
export var previousNextLink = "footer-module--previousNextLink--HJe2J";
export var previousLink = "footer-module--previousLink--1QnUJ";
export var nextLink = "footer-module--nextLink--1iPv3";
export var previousNextImageContainer = "footer-module--previousNextImageContainer--2bYkk";
export var previousNextImage = "footer-module--previousNextImage--3_R2O";
export var previousNextGatsbyImage = "footer-module--previousNextGatsbyImage--XCpIV";
export var relatedProjectsRow = "footer-module--relatedProjectsRow--2PRUM";
export var relatedProjects = "footer-module--relatedProjects--2ljIQ";
export var relatedProjectCard = "footer-module--relatedProjectCard--3oYdL";
export var relatedProjectCardImageContainer = "footer-module--relatedProjectCardImageContainer--2qX72";
export var relatedProjectCardImage = "footer-module--relatedProjectCardImage--2xEu1";
export var relatedProjectCardLink = "footer-module--relatedProjectCardLink--LRJ27";
export var relatedProjectCardGatsbyImage = "footer-module--relatedProjectCardGatsbyImage--Zy21G";
export var relatedProjectCardTitle = "footer-module--relatedProjectCardTitle--E3Ymg";